import { z } from 'zod';

import { ClearVerifyStaffRole } from 'src/api';

import { AccessFormField } from './constants';

/** Spread into the schema of a form that renders `ClearVerifyStaffAccessFormPart`. */
export const accessValidationShape = {
  [AccessFormField.role]: z.enum(ClearVerifyStaffRole),
  [AccessFormField.isFinancialReportAvailable]: z.boolean(),
  [AccessFormField.isRecipientForMonthlyFinancialReport]: z.boolean(),
};
